import React from 'react';
import './ShowForm.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";

const ShowForm = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className="show__form">
              <HeaderPrint
                color={"#1B9C85"}
                englishTitle={"Show form"}
                persianTitle={"نمایش فرم"}
              />
              <div className="show__form__text__box">
                <div className="show__form__text iransans-b">
                  <div className="print__subsystems__name">
                    <span>کد فرم</span>
                    <span>:</span>
                    <span>123456</span>
                  </div>
                  <div className="print__subsystems__phone">
                    <span>عنوان فرم</span>
                    <span>:</span>
                    <span>{item.title}</span>
                  </div>
                </div>
                <div className="show__form__text iransans-b">
                  <div>
                    <span>کد فرم</span>
                    <span>:</span>
                    <span>123456</span>
                  </div>
                </div>
                <div className="show__form__text iransans-b">
                  <div className="print__subsystems__phone">
                    <span>تاریخ</span>
                    <span>:</span>
                    <span>{item.date}</span>
                  </div>
                  <div>
                    <span>کاربـر</span>
                    <span>:</span>
                    <span>{item.user}</span>
                  </div>
                </div>
              </div>
              <div className="show__form__boxes">
                <div className="show__form__diagram iransans">
                  <img src={item.formUrl} alt="No image found"/>
                </div>
                <div className="show__form__description iransans">
                  توضیحات
                </div>
              </div>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ShowForm;